// react
import { useSelector } from 'react-redux';

// api
import { useUnitsGetCollectionAsyncByqueryOptionsQuery } from '@/api/generated/recalc/endpoints/v1/units';

// components
import useStableSearchParams from '@/hooks/useStableSearchParams';
import { getSelectedAccount } from '@/redux/selectedAccountSlice';

// relative
import type { ReadUnitDto } from '../types';

function useSelectedUnits(): [ReadUnitDto[], (ids: number[]) => void] {
  const accountId = useSelector(getSelectedAccount).AccountId;
  const [searchParams, setSearchParams] = useStableSearchParams();

  const { data: units, isSuccess: unitsOk } =
    useUnitsGetCollectionAsyncByqueryOptionsQuery(
      { 'Account.AccountId': `eq(${accountId})` },
      { skip: !accountId },
    );

  const selectedUnitIds = searchParams.get('units');

  const setSelectedUnitIdsInUrl = (ids: number[]) => {
    setSearchParams((prev: URLSearchParams) => {
      const nextParams = new URLSearchParams(prev);
      if (ids && ids.length) {
        nextParams.set('units', ids.join(','));
      } else {
        nextParams.delete('units');
      }
      return nextParams;
    });
  };

  if (!unitsOk || !units?.length || !selectedUnitIds)
    return [[], setSelectedUnitIdsInUrl];

  const idSet = new Set(selectedUnitIds.split(',').map(Number));
  const selectedUnits = units.filter((u) => idSet.has(Number(u.UnitId)));

  return [selectedUnits, setSelectedUnitIdsInUrl];
}

export default useSelectedUnits;
